import { isEmpty } from 'underscore';

export const useDataState = (allData, selectedData) => {
  let noDataMsgKey = null;
  const noData = isEmpty(allData);
  const noSelected = isEmpty(selectedData);

  if (noData && noSelected) {
    noDataMsgKey = _TL_('There are no Facebook reviews to import from the last 2 years.');
  } else if (noSelected) {
    noDataMsgKey = _TL_('No reviews selected to import from Facebook.');
  }

  return {
    noDataMsgKey,
    noData,
  };
};
